import type { BatteryLifecycleStatus } from '../../../../types';

export const TEST_ID = 'batteryLifecyclePill';

// Lifecycle statuses are hyphenated ('in-service'), so they cannot index the styles
// module directly the way single-word readiness statuses do. Map each status to its
// class-safe key so `styles.lifecycleInService` etc. resolve.
export const LIFECYCLE_CLASS_KEYS: Record<BatteryLifecycleStatus, string> = {
    hold: 'lifecycleHold',
    'in-service': 'lifecycleInService',
    retired: 'lifecycleRetired'
};
